export const APPLY_FORM_STORAGE_KEY = "swiftcreditApplyForm";

const safeParse = (value) => {
  if (!value) {
    return {};
  }

  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

export const loadApplyFormData = () => {
  if (typeof window === "undefined") {
    return {};
  }

  return safeParse(window.localStorage.getItem(APPLY_FORM_STORAGE_KEY));
};

export const saveApplyFormData = (nextData) => {
  if (typeof window === "undefined") {
    return;
  }

  const previous = loadApplyFormData();
  const merged = {
    ...previous,
    ...nextData,
  };

  window.localStorage.setItem(APPLY_FORM_STORAGE_KEY, JSON.stringify(merged));
};

export const replaceApplyFormData = (nextData) => {
  if (typeof window === "undefined") {
    return;
  }

  const resolvedData = nextData && typeof nextData === "object" ? nextData : {};
  window.localStorage.setItem(APPLY_FORM_STORAGE_KEY, JSON.stringify(resolvedData));
};

export const clearApplyFormData = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(APPLY_FORM_STORAGE_KEY);
};
